<template>
  <ion-app id="app">
    <ion-header class="desktop-header">
      <ion-toolbar>
         <ion-buttons slot="start">
            <ion-button v-if="$route.meta.showBack" @click="$router.go(-1)">
            <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title color="primary">{{ title }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content overflow-scroll="true" main>
      <ion-page class="container">
        <router-view />
      </ion-page>
    </ion-content>
  </ion-app>
</template>
<script>
export default {
  methods: {
    goBack() {
      this.$router.back();
    }
  },
 computed: {
    title() {
      if (this.$store.state.ui.header && this.$store.state.ui.header.title) {
        return this.$store.state.ui.header.title;
      }
      return "";
    }
  },
}
</script>
